import { render, staticRenderFns } from "./CourseVideoTemplate.vue?vue&type=template&id=edf5b72c&scoped=true&"
import script from "./CourseVideoTemplate.vue?vue&type=script&lang=js&"
export * from "./CourseVideoTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf5b72c",
  null
  
)

export default component.exports